export interface CurrencySetting {
  CurrencyId: number;
  TargetAmount: number;
  ActualRate: number;
}

export interface GoldenDuelSetting {
  SportId: number;
  LeagueIds: number[];
  CurrencySettings: CurrencySetting[];
}

export interface GroupDate {
  GroupId: string;
  DrawTime: string;
  Status: boolean;
}

export interface GroupByMatchIdData {
  DrawTime: string;
}

export interface GroupByMatchIdsData {
  DrawTime: string;
  MatchId: number;
}

export interface Match {
  MatchId: number;
  GameNo: number;
  SeriesRecord: string;
  HomeId: number;
  AwayId: number;
  HomeName: string; // ex. PHX
  AwayName: string; // ex. MIA
  HomeFtScore?: number;
  AwayFtScore?: number;
  Event: string;
}

export interface MatchDetail extends Match {
  HomeHtScore?: number;
  AwayHtScore?: number;
}


export interface MatchGroup {
  GroupId: string;
  Status: GroupStatus;
  PoolAmount: number;
  DrawTime: string;
  Matches: Match[];
}

export interface Group {
  GroupId: string;
  Status: number;
  PoolAmount: number;
  DrawTime: string;
}

export interface WinNumber {
  Event: string;
  TeamName: string;
  Stats: number;
  Statistic: number;
  Picked: number;
  MatchId: number;
}

export interface PrizeDetail {
  LastRemainAmount: number;
  PoolAmount: number;
}

export interface PrizeDrawDetail {
  PrizeLevel: number;
  Prize: number;
  TicketCount: number;
  PrizeFund: number;
}

export interface MatchGroupDetail {
  PrizeLevel: number;
  Status: GroupStatus;
  PrizeTotalAmount: number;
  DrawTime: string;
  WinNumber: string;
  WinNumberSource: WinNumber[];
  Matches: MatchDetail[];
  PrizeDetail: PrizeDetail;
  PrizeDrawDetail: PrizeDrawDetail[];
  NextGameDetail: MatchGroupNextGame;
}

export enum JoinType {
  NotInPool = 0,  // 不在此獎池
  PendingInPool = 1  // 同獎池未開賽
}

export interface MatchGroupNextGame {
  MatchId: number;
  GameNo: number;
  JoinType: JoinType;
  HomeName: string;
  AwayName: string;
}

export enum FilterType {
  None = 0,
  DrawDate = 1,
  Teams = 2,
  DrawResult = 3
}

export interface GetMatchGroupsRequest {
  filterType: FilterType;
  /** 若 filterType 為 DrawDate 或 DrawResult, 要回傳 GMT-4 時間 ex.'04/23' */
  drawTime: string;
}

export interface GetTicketGroupsRequest {
  /** format: 'MM/dd' */
  startDate: string;
  /** format: 'MM/dd' */
  endDate: string;
}

export enum GroupStatus {
  Pending = 0,    // 未派彩
  Drawn = 1       // 已開獎
}

export interface TicketGroup {
  GroupId: string;
  Status: GroupStatus;
  DrawTime: string;
  WinNumber: string;
  Tickets: Ticket[];
}

export enum TicketStatus {
  Lost = 0,       // 未中獎
  Won = 1,        // 中獎
  Canceled = 2    // 取消
}

export interface Ticket {
  MatchId: number;
  TransId: number;
  HomeName: string;
  AwayName: string;
  PrizeAmount: number;
  TransDate: string;
  Status: TicketStatus;
}

export interface GetWinningNotifyResponse {
  GroupId: string;
}